import React from 'react'
import AdmDayBook from '../../components/AdminTabs/AdminDayBook/AdmDayBook'

const DayBook = () => {
  return (
    <div>
      <AdmDayBook/>
    </div>
  )
}

export default DayBook
